/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FaxesFindAllResponse } from './FaxesFindAllResponse';
import {
    FaxesFindAllResponseFromJSON,
    FaxesFindAllResponseFromJSONTyped,
    FaxesFindAllResponseToJSON,
} from './FaxesFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllFaxes200Response
 */
export interface FindAllFaxes200Response {
    /**
     * 
     * @type {FaxesFindAllResponse}
     * @memberof FindAllFaxes200Response
     */
    data?: FaxesFindAllResponse;
}

/**
 * Check if a given object implements the FindAllFaxes200Response interface.
 */
export function instanceOfFindAllFaxes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllFaxes200ResponseFromJSON(json: any): FindAllFaxes200Response {
    return FindAllFaxes200ResponseFromJSONTyped(json, false);
}

export function FindAllFaxes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFaxes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FaxesFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllFaxes200ResponseToJSON(value?: FindAllFaxes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FaxesFindAllResponseToJSON(value.data),
    };
}

